
export default {
  vessel: {
    infoBar: {
      color: 'white',
      fontSize: 'sm'
    }
  }
}
